<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WXBqLW/tc-custom/9783958644229.jpg?1703042124897" alt="This image is the cover for the book The Man from Archangel, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Man from Archangel, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Sir Arthur Ignatius Conan Doyle (22 May 1859 – 7 July 1930) was a Scottish writer and physician, most noted for his fictional stories about the detective Sherlock Holmes, which are generally considered milestones in the field of crime fiction. This is  a collection of short stories, split in to two sections, beginning with the 'Tales of Adventure', of which The Man from Archangel belongs to. It then moves on to 'Tales of Medical Life', which are influenced by Sir Conan Doyle's career as a physician. (Excerpt from Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. Conan Doyle
      </h2>
      
      <p class="authorDescription body article">Sir Arthur Ignatius Conan Doyle KStJ DL (22 May 1859 – 7 July 1930) was a British writer best known for his detective fiction featuring the character Sherlock Holmes. Originally a physician, in 1887 he published A Study in Scarlet, the first of four novels and more than fifty short stories about Holmes and Dr. Watson. The Sherlock Holmes stories are generally considered milestones in the field of crime fiction. Doyle was a prolific writer; his non-Sherlockian works include fantasy and science fiction stories about Professor Challenger and humorous stories about the Napoleonic soldier Brigadier Gerard, as well as plays, romances, poetry, non-fiction and historical novels. One of Doyle's early short stories, "J. Habakuk Jephson's Statement", helped to popularise the mystery of the Mary Celeste. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?440dbd04